import { Button, Center, Container, Stack, Text } from "@mantine/core";
import { Icon } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import UserProfileService from "../services/UserProfileService";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store/store";
import { login } from "../store/features/authSlice";
import { TOKEN_EXP } from "./LoginPage/LoginPage";

const PaymentCallback = () => {
    const { search } = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    const user = useSelector((state: RootState) => state.auth);
    const [ title, setTitle ] = useState("");
    const [ subTitle, setSubTitle ] = useState("");
    const [ loading, setLoading ] = useState(false);

    useEffect(() => {
        console.log("Params:", search);
        
        if(search.length > 0)
        {
            if(search.split('?')[1] === "canceled=true")
            {
                setTitle("❌ Acquisto cancellato");
                setSubTitle("");
            }

            if(search.split('?')[1] === "success=true") 
            {
                setTitle("🎉 Acquisto avvenuto con successo!");
                setSubTitle("Puoi tornare nell'applicazione NowCheckin ed aggiornare la licenza");
            }
        }
    }, []);

    const onClickHandler = async () => {
        // When a purchase was successfully done
        if(search.split('?')[1] === "success=true")
        {
            setLoading(true);

            // Reload fresh user profile
            let up = await UserProfileService.getUserProfile(user.token!);

            dispatch(login({ ...up, token: user.token!, expiration: TOKEN_EXP }));
        }
        
        setLoading(false);
        navigate("/");
    };

    return(
        <Container>
            <Center h={"100vh"}>
                <Stack>
                    <Text fw={600} fz={20}>{ title }</Text>
                    <Text fz={16} style={{ opacity: .4, textAlign: "center" }}>{ subTitle }</Text>

                    <Button 
                        leftSection={<Icon>home</Icon>}
                        color="orange"
                        loading={ loading }
                        onClick={ onClickHandler }
                    >
                        Vai alla home
                    </Button>
                </Stack>
            </Center>
        </Container>
    );
};

export default PaymentCallback;